import { render, staticRenderFns } from "./TitleConfig.vue?vue&type=template&id=771f4628&scoped=true"
import script from "./TitleConfig.vue?vue&type=script&lang=js"
export * from "./TitleConfig.vue?vue&type=script&lang=js"
import style0 from "./TitleConfig.vue?vue&type=style&index=0&id=771f4628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f4628",
  null
  
)

export default component.exports